module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.scss
// module id = ./web/modern/components/brands/modals/save-languages-modal/save-languages-modal.scss
// module chunks = 0